angular.module('articles_setup_module').controller('ArticlesMetaSetupController', ['$scope', 'ArticlesMetaSetupFactory',
    'SETUPCONSTANTS',
    function ($scope, ArticlesMetaSetupFactory, SETUPCONSTANTS) {
        $scope.SETUPCONSTANTS = SETUPCONSTANTS;
    }]);